import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"

import "alpine-turbo-drive-adapter"
import Alpine from "alpinejs"

import { init_toasts } from "./toasts"
import "./creatable_select"

window.Alpine = Alpine

Alpine.data("modifier_table", () => ({
  open_edit(url) {
    document.getElementById("edit-modifier-frame").src = url
    bootstrap.Offcanvas.getOrCreateInstance(
      document.getElementById("edit-modifier-offcanvas")
    ).show()
  }
}))

Alpine.data("search_form", () => ({
  async search(event) {
    const query = event.target.querySelector('input[name="q"]').value.trim()
    if (!query) return
    try {
      const url = new URL("/search", window.location.origin)
      url.searchParams.set("q", query)
      const response = await fetch(url.toString(), { headers: { Accept: "application/json" } })
      const data = await response.json()
      document.dispatchEvent(new CustomEvent("app:toast", {
        detail: { message: data.message ?? "Search is not yet available.", type: "warning" }
      }))
    } catch {
      document.dispatchEvent(new CustomEvent("app:toast", {
        detail: { message: "Search is currently unavailable.", type: "danger" }
      }))
    }
  }
}))

Alpine.start()
document.addEventListener("turbo:load", init_toasts)
window.addEventListener("load", init_toasts)

document.addEventListener("turbo:submit-end", (event) => {
  if (event.detail.success) {
    document.querySelectorAll(".modifier-offcanvas.show").forEach((el) => {
      bootstrap.Offcanvas.getInstance(el)?.hide()
    })
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body?.classList.remove("modal-open")
  }
})
